import React, { useState, useEffect } from 'react';
import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import CustomCheckbox from '../../shared/CustomCheckbox';
import RoleBottomSheet from './RoleBottomSheet';

const useStyles = makeStyles({
  title: {
    fontFamily: 'Lato',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '22.4px',
  },
  mainContainer: {
    padding: '20px',
  },
  detailsContainer: {
    marginLeft: '22px',
    padding: '15px 15px 0px 15px',
  },
  bottomSheetBtnContainer: {
    background: 'white',
    borderBottom: '1px solid #E4E7EC',
  },
  deptMainBox: {
    width: '981px',
    height: '48px',
    padding: '0px 0px 0px 12px',
    borderRadius: '8px',
    border: '1px solid rgba(228, 231, 236, 1)',
    background: 'rgba(254, 254, 254, 1)',
    margin: '16px 0px 0px 37px',
  },
  deptBox: {
    paddingLeft: '10px',
    borderRight: '1px solid rgba(228, 231, 236, 1)',
  },
  roleBoxMain: {
    width: '981px',
    minHeight: '250px',
    padding: '0px 0px 0px 12px',
    borderRadius: '8px',
    border: '1px solid rgba(228, 231, 236, 1)',
    background: 'rgba(254, 254, 254, 1)',
    margin: '16px 0px 0px 37px',
  },
  roleBox: {
    paddingLeft: '10px',
    height: '100%',
    borderRight: '1px solid rgba(228, 231, 236, 1)',
  },
  bottomSheetBtn: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '16.08px',
    color: 'rgba(98, 47, 238, 1)',
  },
});

const RoleLevelConfig = ({ handleChange, data, handleDeptChange, departmentData }) => {
  const [isSheetOpen, setSheetOpen] = useState(false);
  const classes = useStyles();
  const [department, setDepartment] = useState(departmentData);

  useEffect(() => {
    if (departmentData) {
      setDepartment(departmentData);
    }
  }, [departmentData]);

  const toggleSheet = () => {
    setSheetOpen((prev) => !prev);
  };

  const handleCheckbox = (e) => {
    const { value, checked } = e.target;
    const roleId = parseInt(value, 10);
    setDepartment((prevDepartments) =>
      prevDepartments.map((dept) => ({
        ...dept,
        roles: dept.roles.map((role) => (role.id === roleId ? { ...role, selected: checked } : role)),
      })),
    );
    handleChange(e);
  };

  const handleSelectAllRoles = (deptId, isSelected) => {
    setDepartment((prevDepartments) =>
      prevDepartments.map((dept) =>
        dept.id === deptId
          ? {
              ...dept,
              roles: dept.roles.map((role) => ({
                ...role,
                selected: isSelected,
              })),
            }
          : dept,
      ),
    );
    handleDeptChange(deptId, isSelected, department || []);
  };

  return (
    <Grid container direction="column" justifyContent="space-between" style={{ height: '100%' }}>
      <Grid item>
        <Grid container>
          <Grid item className={classes.detailsContainer}>
            <Typography className={classes.title}>Select Roles</Typography>
          </Grid>
          <Grid container direction="row" className={classes.deptMainBox} alignItems="center">
            {department?.map((item) => (
              <Grid item xs={3} className={classes.deptBox} key={item.id}>
                <CustomCheckbox
                  selected={item?.roles?.every((role) => data?.departmentRoleIds?.includes(role.id))}
                  indeterminate={
                    item?.roles?.some((role) => data?.departmentRoleIds?.includes(role.id)) &&
                    !item?.roles?.every((role) => data?.departmentRoleIds?.includes(role.id))
                  }
                  value={item.id}
                  label={item.name}
                  size="14px"
                  weight="600"
                  handleChange={(e) => handleSelectAllRoles(item.id, e.target.checked)}
                />
              </Grid>
            ))}
          </Grid>
          <Grid container direction="row" className={classes.roleBoxMain} alignItems="flex-start">
            {department?.map((dept) => (
              <Grid item xs={3} className={classes.roleBox} key={dept.id}>
                <Grid container direction="column">
                  {dept?.roles?.map((role) => (
                    <Grid item key={role.id}>
                      <CustomCheckbox
                        value={role.id}
                        label={role.name}
                        selected={data?.departmentRoleIds?.includes(role.id)}
                        size="12px"
                        weight="500"
                        name="departmentRoleIds"
                        handleChange={handleCheckbox}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.bottomSheetBtnContainer}
        >
          <Grid item>
            <Button variant="text" onClick={toggleSheet} className={classes.bottomSheetBtn}>
              {`${data?.departmentRoleIds?.length} Roles Selected`}
            </Button>
          </Grid>
        </Grid>
        <RoleBottomSheet
          style={{
            position: 'sticky',
            bottom: 0,
            background: 'white',
            padding: '10px',
            zIndex: 10,
          }}
          data={data?.departmentRoleIds}
          isOpen={isSheetOpen}
          onClose={toggleSheet}
          department={department}
        />
      </Grid>
    </Grid>
  );
};

export default RoleLevelConfig;
